import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmailVerifyModalService {
  private openModalSource = new Subject<string>();
  openModal$ = this.openModalSource.asObservable();

  private closeModalSource = new Subject<void>();
  closeModal$ = this.closeModalSource.asObservable();

  open(email: string) {
    this.openModalSource.next(email);
  }

  close() {
    this.closeModalSource.next();
  }
}
